"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CaretLeftFill = {
    name: 'caret-left',
    theme: 'fill',
    nameWithTheme: 'caret-left-fill',
    tag: 'svg',
    attrs: { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 1024 1024' },
    children: [
        {
            tag: 'path',
            attrs: {
                d: 'M631.3 76.3l-489.2 403c-18.9 16.9-18.9 46.5 0 63.4l489.1 405.1c27.4 24.4 70.8 5 70.8-31.7V107.9c0-36.6-43.4-56.1-70.7-31.6z'
            },
            children: []
        }
    ]
};
exports.default = CaretLeftFill;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@1.0.3@@ant-design/icons/lib/fill/CaretLeftFill.js
// module id = 313
// module chunks = 0 1